import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import DEATH_API from "../../../apis/death.api";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import linkedIcon from "../../../assets/images/DeathModuleNew/accountLink.png";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Table, Tooltip } from "antd";
import "../LiabilityDashboard.css";
import { useSelector } from "react-redux";
import warningSign from "../../../assets/SVGs/warningSign.svg"
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import { Modal, Tag, Input, Checkbox, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { calculateAmortization } from "../../../helpers/amortizationCalcultion";


export const CreditTable = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const tableLoader = {
    spinning: props.loading || loading,
    indicator: <LoadingOutlined style={{ fontSize: 20, color: "#2a3da3" }} spin />,
  };
  const [dropdown, setDropdown] = useState(false);
  const [isReqModal, setIsReqModal] = useState(false)
  const [modalData, setModalData] = useState({});
  const [missingFields, setMissingFields] = useState([]);

  const [selectedIndex, setSelectedIndex] = useState(null);
  const refreshTime = useSelector(
    (state) => state.rootReducer.itemsInfo.refreshTimeAsset
  );
  const handleWarningClick = (record) => {
    setModalData([])
    const requiredFields = ["Start Date", "Maturity Date", "Interest Rate", "Initial Loan Amount"];

    const missing = requiredFields.filter(
      (field) => !record[field] || record[field] === ""
    );

    const prefill = {
      "Start Date": record["Start Date"] || "",
      "Maturity Date": record["Maturity Date"] || "",
      "Interest Rate": record["Interest Rate"] || "",
      "Initial Loan Amount": record["Initial Loan Amount"] || "",
    };

    const {
      ["Start Date"]: _sd,
      ["Maturity Date"]: _md,
      ["Interest Rate"]: _ir,
      ["Initial Loan Amount"]: _ila,
      ...rest
    } = record;

    // Merge with existing modalData (e.g., to keep id or other fields)
    setModalData((prev) => ({
      ...prev,
      ...rest,
      ...record
    }));

    setMissingFields(missing);
    setIsReqModal(true);
  };


  const handleInputChange = (name, value) => {
    setModalData((prev) => ({
      ...prev,
      [name]: ["Start Date", "Maturity Date"].includes(name) ? moment(value).toISOString() : value,
    }));
  };

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const Creditscols = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Financial Institution",
      dataIndex: "Name of Financial Institution",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? // ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            `$${parseFloat(record)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    {
      title: "Interest Rate(%APR)",
      dataIndex: "Interest Rate",
      render: (record) => (record ? `${parseFloat(record).toFixed(2) + "%"} ` : "0.00%"),
    },
    {
      title: "Maturity Date",
      dataIndex: "Maturity Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Loan Balance",
      dataIndex: "Loan Balance",
      render: (record, row) => {
        const value = row && row["Loan Balance"] || row["Initial Loan Amount"];
        return value
          ? !isNaN(value)
            ? `${"$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A";
      }
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999", width: "16%" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        fnView(record);
                        setDropdown(false);
                      }}>
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        fnEdit(record);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                    <li
                      className="liHover"
                      // style={{
                      //   opacity: record.managedBy === "Plaid" ? "0.3" : "1",
                      //   cursor:
                      //     record.managedBy === "Plaid"
                      //       ? "not-allowed"
                      //       : "pointer",
                      //   pointerEvents:
                      //     record.managedBy === "Plaid" ? "none" : "",
                      // }}
                      onClick={() => {
                        deletePost(record.id, record.managedBy, record);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
            {/*record.managedBy === "Plaid" && (
            <div className="managed-by-plaid-icon"> </div>
            
            )*/}
            {(
              !record["Start Date"] ||
              !record["Maturity Date"] ||
              !record["Interest Rate"] ||
              !record["Initial Loan Amount"]
            ) && (
                <button
                  style={{ background: "transparent", border: "none" }}
                  onClick={() => handleWarningClick(record)}
                >
                  <img src={warningSign} />
                </button>
              )}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            style={{
              cursor: "pointer",
              width: "18px",
              height: "18px",
            }}
            src={linkedIcon}
            alt="linkedIcon"
          ></img>
        </div>
      ),
      render: (record) => {
        return (
          <div style={{ display: "flex", minHeight: "40px", cursor: "pointer" }}>
            {record.managedBy === "Plaid" && (
              <Tooltip title="This icon indicates that the account is securely linked with our trusted financial data provider, allowing for real-time balance updates and transaction synchronization. The connection enables seamless financial tracking without manual entry.">
                <div className="managed-by-plaid-icon"> </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const deleteLinkTransactions = async (id, record) => {
    await swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${record["Nickname of Liabilities"]
        ? record["Nickname of Liabilities"]
        : "Liability"
        } ? All Transactions in Budget will be deleted as well.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          let payload = {
            cmId: id,
          };
          const resposnse = await DEATH_API.deleteLinkTransactions(payload);
          if (resposnse && resposnse.status === 200) {
            swal("Success", resposnse.message, "success");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transactions are safe :)", "error");
      }
    });
  };
  const deletePost = async (id, managedBy, recordToDelete) => {
    console.log("delete is", id);
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          if (managedBy === "Plaid") {
            await deleteLinkTransactions(id, recordToDelete);
          }
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          // if (res && res.status === 200 && managedBy === "Plaid") {
          //   deleteLinkTransactions(id, recordToDelete);
          // }
          // setLiabilitesCredit([]);
          // setCreditRows([]);
          setLoading(false);
          props.updateSharedState(!props.sharedState);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };

  const fnEdit = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}`
    );
  };
  const fnView = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}/view`
    );
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "white",
        formatter: (value, context) => `${value}%`,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
    },
    tooltips: {
      // enabled: false,
      callbacks: {
        label: (tooltipItem, data) => {
          // Get the dataset label, global label or fall back to empty label
          let label =
            (data.datasets[tooltipItem.datasetIndex].labels &&
              data.datasets[tooltipItem.datasetIndex].labels[
              tooltipItem.index
              ]) ||
            data.datasets[tooltipItem.datasetIndex].label ||
            data.labels[tooltipItem.index] ||
            "";
          if (label) {
            label += ": ";
          }

          // Apply the value and suffix
          label +=
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
            (data.datasets[tooltipItem.datasetIndex].labelSuffix || "");

          return label;
        },
      },
    },
    legend: {
      onClick: () => { }, // Disable legend click
    },
  };

  const chartData = {
    labels: props.allCreditRowsForChart ? props.allCreditRowsForChart.map(card => card["Nickname of Credit"] || "N/A") : [],
    datasets: [
      {
        label: "Credit Balance",
        data: props.allCreditRowsForChart ? props.allCreditRowsForChart.map(card => {
          if (card.managedBy === "Plaid") {
            return card["Credit Balance"] || card["Loan Balance"] || 0;
          } else {
            return card["Loan Balance"] || card["Credit Balance"] || 0;
          }
        }) : [],
        backgroundColor: "#B1E3FF",
      },
      {
        label: "Credit Limit",
        data: props.allCreditRowsForChart ? props.allCreditRowsForChart.map(card => {
          const limit = +card["Credit Limit"] || 0;
          const balance = card.managedBy === "Plaid"
            ? (card["Credit Balance"] || card["Loan Balance"] || 0)
            : (card["Loan Balance"] || card["Credit Balance"] || 0);
          const remaining = limit - balance;
          return remaining < 0 ? 0 : remaining;
        }) : [],
        backgroundColor: "#2A3DA3",
      },
    ],
  };
  const upgrade = () => {
    history.push("/payment");
  };
  const refresh = async () => {
    await props.refreshModule();
    props.updateSharedState(!props.sharedState);
  };

  const renderField = (label, name, type = "text") => {
    const isMissing = missingFields.includes(label);
    // const value = modalData[name];
    // console.log("moduleDate----",modalData)

    const rawValue = modalData[name];

    // Format date string to 'YYYY-MM-DD' if type is date and value exists
    const value =
      type === "date" && rawValue
        ? moment(rawValue).toISOString()
        : rawValue || "";

    return (
      <div style={{ marginBottom: "8px" }}>
        <h3 className="inputTitle">
          {label}{" "}
          {isMissing && <span style={{ color: "red" }}>*</span>}
        </h3>
        <input
          type={type}
          className="roleInput"
          name={name}
          value={type === "date" ? moment(value).format("YYYY-MM-DD") : value}
          readOnly={!isMissing}
          min={type === "number" ? 0 : undefined}
          step={type === "number" ? "0.01" : undefined}
          onChange={
            isMissing
              ? (e) => handleInputChange(name, e.target.value)
              : undefined
          }
        />
      </div>
    );
  };

  const isSaveDisabled = missingFields.some((field) => {
    switch (field) {
      case "Start Date":
        return !modalData["Start Date"]; // renamed key
      case "Maturity Date":
        return !modalData["Maturity Date"];
      case "Interest Rate":
        return !modalData["Interest Rate"];
      case "Initial Loan Amount":
        return !modalData["Initial Loan Amount"];
      default:
        return false;
    }
  });


  const handleSubmitAmortization = async (id, data) => {
    try {
      setLoading(true);
      if (data) {
        //  let payload={...data}
        let payload = {
          liabilityId: +id,
          amotizaion: data,
        };
        const response = await MODULE_API.postDebtData(id, payload);
        console.log("response", response);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };

  const handleSubmit = async (moduleData) => {

    try {
      const { formattedLiabilityData, monthlyPayment } = calculateAmortization(moduleData.id, moduleData, moduleData.module)
      const res = await MODULE_API.updateClientModule(moduleData.id, {
        ...moduleData,
        "Monthly Payment": monthlyPayment
      }
      );
      console.log("formattedLiabilityData---", formattedLiabilityData)
      await handleSubmitAmortization(moduleData.id, formattedLiabilityData);
      props.updateSharedState(!props.sharedState);
      setModalData([])
      if (res && res.status === 400) {
        if (res.message) {
          swal({
            title: "Error",
            text: res.message,
            icon: "error",
            buttons: true,
            dangerMode: true,
          });
        }
        return
      }
      history.push("/liabilities_credit");
    } catch (err) {
      console.log("Error while updating loan data...".err)
    }
  }


  return (
    <React.Fragment>
      <div
        className="creditDebtCard"
        style={{
          display:
            props.creditRows && props.creditRows.length > 0 ? "flex" : "block",
          flexDirection:
            props.creditRows && props.creditRows.length > 0
              ? "column"
              : "column",
          flexGrow: props.creditRows && props.creditRows.length > 0 ? "1" : "0",
        }}>
        <h3 className="liablitycardheading">Debt Information</h3>
        {props.loadingChartData ? (
          <div style={{ marginTop: "2rem", display: "flex", flexDirection: "column", flexGrow: "1", alignItems: "center", justifyContent: "center" }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#2a3da3" }} spin />} />
            <span style={{ marginTop: "10px", color: "#5f6a8a" }}>Loading chart...</span>
          </div>
        ) : props.allCreditRowsForChart && props.allCreditRowsForChart.length > 0 ? (
          <div style={{ marginTop: "2rem", display: "flex", flexGrow: "1" }}>
            <Bar data={chartData} options={options} height={400} width={400} />
          </div>
        ) : (
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              flexGrow: "1",
              alignItems: "center",
              justifyContent: "center",
            }}>
            No Chart data to show
          </div>
        )}
      </div>
      <div className="creditDebtCard2" style={{ position: "relative" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}>
          <h3 className="liablitycardheading">Loans (Not Credit Cards)</h3>
          {userRole && (userRole !== "FreeTrail" && userRole !== "Financial Advisor Client") && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "1rem",
                color: "black",
              }}>
               <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                color: "black",
              }}
            >
              <button
                className="addbuttonLiablity"
                style={{ paddingInline: "1rem" }}
                disabled={props.refreshingModule}
                onClick={() => {
                  if (props.refreshingModule) return;
                  refresh();
                  // handleButtonClick();
                }}>
                {props.refreshingModule ? (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                    <LoadingOutlined spin />
                    Refreshing...
                  </span>
                 ) : (
                  "Refresh Liabilities"
                )}
              </button>
              <ToolTipCreator name="Refresh Liabilities" />
              </div>
              {refreshTime &&
                `Updated at: ${moment(refreshTime)
                  .local()
                  .format("MM/DD/YYYY [at] hh:mmA")}`}
            </div>
          )}
        </div>
        {/* <List cols={Creditscols} rows={props.liabilitiesCredit && props.liabilitiesCredit} /> */}
        <Table
          columns={Creditscols}
          dataSource={props.liabilitiesCredit && props.liabilitiesCredit}
          loading={tableLoader}
          pagination={{
            total: props.totalPages * 10, // Assuming 10 items per page
            current: props.currentPage,
            onChange: (page) => {
              props.setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
        <Modal
          visible={isReqModal}
          footer={null}
          // onOk={handleCancel}
          onCancel={() => { setIsReqModal(false) }}
          closable={true}
          centered
        >
          <h3 className="modaltitle">Required Fields</h3>

          {renderField("Start Date", "Start Date", "date")}
          {renderField("Maturity Date", "Maturity Date", "date")}
          {renderField("Interest Rate", "Interest Rate", "number")}
          {renderField("Initial Loan Amount", "Initial Loan Amount", "number")}


          <div className="buttonsMain" style={{ justifyContent: "center" }}>
            <button
              className="savebutton"
              style={{ marginLeft: "10px", background: "#ccc" }}
              onClick={() => {
                setIsReqModal(false)
                setModalData([])
              }}
            >
              Close
            </button>
            <button
              className="savebutton"
              disabled={isSaveDisabled}
              style={{ opacity: isSaveDisabled && "0.7", cursor: isSaveDisabled ? "not-allowed" : "pointer" }}
              onClick={async () => {
                console.log("Saving this:", modalData);
                setIsReqModal(false);
                await handleSubmit(modalData)
              }}
            >
              Save
            </button>
          </div>

        </Modal>
      </div>
    </React.Fragment>
  );
};
